import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cartUtils from '../../../../utils/cart';
import { formatAddressLines } from '../../../../utils/format_address';
import CheckoutEmailDisplay from './CheckoutEmailDisplay';

const Wrapper = styled.div`
  margin-top: 0;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 24px 24px;
  margin-bottom: 32px;
`;

const Header1 = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #479de6;
`;

const Header2 = styled.div`
  font-size: 14px;
  margin-top: 0;
`;

const ContactLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  margin-top: 16px;

  @media (max-width: 767px) {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StackedContactLine = styled.div`
  margin-top: 16px;
`;

const ContactLineLessMargin = styled(ContactLine)`
  margin-top: 4px;
`;

const ContactLabel = styled.p`
  margin: 0;
`;

const ContactData = styled.p`
  margin: 0;
  margin-bottom: 10px;
  font-weight: bold;

  @media (max-width: 767px) {
    margin-top: 4px;
  }
`;

const EditLinkStyled = styled(Link)`
  text-decoration: underline;
  color: #479de6;
  cursor: pointer;
  margin-top: 16px;
`;

const CustomerDetails = ({ cartTotals }) => {
  const {
    address: { address1, address2, city, state, zipcode, country },
    email,
    unconfirmedEmail,
    emailConfirmedAt,
    needsConfirmation,
    authProvider,
    phone,
    smsPhone,
  } = useSelector((state) => state.parent);
  const { orders } = useSelector((state) => state.v3Order);

  const formattedPhoneNumber = parsePhoneNumberFromString(
    smsPhone || phone,
    'US',
  );

  return (
    <>
      {cartUtils.cartContainsShippingRequiredProducts(orders) && (
        <Wrapper>
          <Header1>Address</Header1>
          <ContactLine>
            <p>
              For ship-to-home orders, please ensure that the below address is
              where you'd like your order shipped.
            </p>
          </ContactLine>

          {/* <div className="alert alert-info">
          This is the explainer paragraph that provides additional context or
          information about the address shown below.
        </div> */}
          <Header2>
            <ContactLineLessMargin>
              <ContactData>
                {formatAddressLines({
                  address1,
                  address2,
                  city,
                  state,
                  zipcode,
                  country,
                }).map((line, i, arr) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < arr.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </ContactData>
            </ContactLineLessMargin>
            <EditLinkStyled to="/v3/checkout/customer-address-edit">
              edit address
            </EditLinkStyled>
          </Header2>
        </Wrapper>
      )}
      <CheckoutEmailDisplay
        email={email}
        unconfirmedEmail={unconfirmedEmail}
        emailConfirmedAt={emailConfirmedAt}
        needsConfirmation={needsConfirmation}
        authProvider={authProvider}
      />
      <Wrapper>
        <Header1>Phone</Header1>
        <StackedContactLine>
          <p>
            Please confirm a mobile number to send any SMS-based products to:
          </p>
          <ContactData>
            {formattedPhoneNumber
              ? formattedPhoneNumber.formatNational()
              : 'Invalid Number'}
          </ContactData>
          <EditLinkStyled to="/v3/checkout/customer-phone-edit">
            edit phone
          </EditLinkStyled>
        </StackedContactLine>
      </Wrapper>
    </>
  );
};

export default CustomerDetails;

CustomerDetails.PropTypes = {
  cartTotals: PropTypes.shape({
    shipping: PropTypes.number,
  }),
};
